import React from 'react'
import './Menu.scss'

import MenuConsultas from './MenuConsultas'

class Menu extends React.Component {
    render() {
        if (this.props.menuAberto) {
            return (
                <aside className="menuFlutuante">
                    <MenuConsultas
                        currentDateTime={this.props.currentDateTime}
                        toggleMenuMobile={this.props.toggleMenuMobile}
                        toggleMenu={this.props.toggleMenu}
                    />
                </aside>
            )
        }
        return <></>
    }
}

export default Menu
